import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
// import { StatusTable, Row } from "@egovernments/digit-ui-react-components";
import { Card } from "@material-ui/core";
// import NOCFormatView from "../../Forms/NOCFormatView";
import { FaFilePdf } from "react-icons/fa";
import ApplicaionFormatView from "../../Forms/ProfessionalForm/ApplicationSummary";
import RegistrationSummary from "../../Forms/ProfessionalForm/RegistrationSummary";
import LTPSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/ltp-registration/Summary/LTPSummary";


const Architect = ({ formData, applicationDocs, totalAmount, actions }) => {
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  // const [smShowNoc, setSmShowNoc] = useState(false);
  // const [smShowPayment, setSmShowPayment] = useState(false);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div style={{ backgroundColor: "rgba(173, 229, 232, 0.69)", padding: "10px" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Box gridColumn="span 2">
            <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
          </Box>
          <Box gridColumn="span 3">
            : &nbsp;&nbsp;&nbsp;{formData?.applicationNumber || ""}
          </Box>
          <Box gridColumn="span 3">
            <button
              className="btn btn-primary"
              style={{ padding: "1px" }}
              onClick={() => {
                setSmShow(true),
                  console.log("modal open")
              }}
            >
              View Application
            </button> </Box>
          <Box gridColumn="span 4">
            {formData?.paymentStatus === "Success" && (
              <button
                className="btn btn-primary"
                style={{ padding: "1px" }}
                onClick={() => {
                  setSmShowPayment(true),
                    console.log("modal open")
                }}
              >
                {t("FASTPAS.GLOBAL.PAYMENT.RECIEPT.TEXT")}
              </button>
            )}
          </Box>

          <Box gridColumn="span 2">
            <b>Mobile Number</b>
          </Box>
          <Box gridColumn="span 10">

            {formData?.tradeLicenseDetail?.owners && formData?.tradeLicenseDetail?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp; {ob?.mobileNumber}
              </div>
            ))}

          </Box>
          <Box gridColumn="span 2" >
            <b>Applicant Name</b>
          </Box>
          <Box gridColumn="span 10">

            {formData?.tradeLicenseDetail?.owners && formData?.tradeLicenseDetail?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp;&nbsp;{ob?.name}
              </div>
            ))}
          </Box>
          <Box gridColumn="span 2">
            <b>Service <span style={{ marginLeft: '80px' }}>:</span></b>
          </Box>
          <Box gridColumn="span 10" sx={{ ml: 2 }}>
            {t("FASTPAS.GLOBAL.TPR.TEXT")}
          </Box>
        </Box>
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => { setSmShow(false) }}
        >
          <LTPSummary
            formData={formData}
            applicationDocs={applicationDocs}
            totalAmount={totalAmount}
          />
        </DialogContentModal>
        {/* <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowNoc}
            onClose={() => { setSmShowNoc(false) }}
          >  
        <NOCFormatView
          formData={formData}
          applicationDocs={applicationDocs}
          totalAmount={totalAmount}
        />
          </DialogContentModal> */}

        {/* <DialogContentModal
            title={"Application Payment Details"}
            dataOpen={smShowPayment}
            onClose={() => { setSmShowPayment(false) }}
          >
            <PaymentPrint
              id={formData?.applicationNo}
            />
          </DialogContentModal> */}

      </div>
      {/* )} */}
    </React.Fragment>
  )
}
export default Architect;